module.exports = __webpack_public_path__ + "static/media/youtubebannertablet.f66db1ec.png";